import { useTranslate } from '@tolgee/react';
import * as PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export default function SideBarButton({
  icon,
  onClick,
  text,
  active,
  disabled,
  color,
  isPlatform
}) {
  const { t } = useTranslate();
  const iconStyle = {
    fontSize: 25
  };
  const {
    data: {
      filters: { platforms }
    }
  } = useSelector((state) => state.communication);
  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 500, hide: 0 }} // Add this line
      overlay={
        <Tooltip>
          <p>
            {!disabled
              ? t(text)
              : t('communication.buttons.only_active_for_posts')}
          </p>
        </Tooltip>
      }
    >
      <div
        className="card w-50px h-50px rounded  d-flex justify-content-center align-items-center cursor-pointer"
        style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}
        onClick={(e) => !disabled && onClick()}
      >
        {isPlatform ? (
          <i
            className={`${icon} text-${active ? color : ''}`}
            style={{
              ...iconStyle,
              color:
                (active || platforms.length === 0) && color ? color : undefined
            }}
          ></i>
        ) : (
          <i
            className={`${icon} ${active ? 'text-primary' : ''}`}
            style={iconStyle}
          ></i>
        )}
      </div>
    </OverlayTrigger>
  );
}

SideBarButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.any,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  isPlatform: PropTypes.bool
};
